import { Injectable, signal, computed } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DashboardStoreService {
  // Signals
  readonly startDate = signal<string>('');
  readonly endDate = signal<string>('');

  // Computed opcional
  readonly period = computed(() => ({
    startDate: this.startDate(),
    endDate: this.endDate()
  }));

  // Métodos para atualização
  setStartDate(date: string): void {
    console.log('setStartDate');

    this.startDate.set(date);
  }

  setEndDate(date: string): void {
    console.log('setEndDate');
    this.endDate.set(date);
  }

  setPeriod(startDate: string, endDate: string): void {
    this.startDate.set(startDate);
    this.endDate.set(endDate);
  }

  clear(): void {
    this.startDate.set('');
    this.endDate.set('');
  }
}
